import api from '../index'
import {
  IGetRules,
  IPostRuleArea,
  IPostRuleProject,
  IPostRuleSubject,
  IGetRulesResponse
} from '../models/rules'

export const getRules = (data: IGetRules) => {
  return api.get<IGetRulesResponse>(`/rules/${data.id}`, { params: data })
}

export const postRuleArea = (data: IPostRuleArea) => {
  return api.post('/rules/area', data)
}

export const postRuleSubject = (data: IPostRuleSubject) => {
  return api.post('/rules/subject', data)
}
export const postRuleProject = (data: IPostRuleProject) => {
  return api.post('/rules/project', data)
}

export const getRuleById = (id: string) => {
  return api.get(`/rules/${id}`)
}
